import { useSelector } from "react-redux";
import { selectCrossBorderTransfer } from "../../redux/slices/crossBorderTransferSlice";
import { CrossBorderRecipientFormUSD } from "./CrossBorderRecipientFormUSD";
import { CrossBorderRecipientFormGeneric } from "./CrossBorderRecipientFormGeneric";

export default function CrossBorderRecipientForm({ onBack, nextRoute }) {
    const cb = useSelector(selectCrossBorderTransfer);
    const toCurrency = (cb?.recipient?.toCurrency || "").toUpperCase();

    if (toCurrency === "USD") {
        return <CrossBorderRecipientFormUSD onBack={onBack} nextRoute={nextRoute} />;
    }

    return <CrossBorderRecipientFormGeneric onBack={onBack} nextRoute={nextRoute} />;
}
